import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from 'styletron-react';
import { sizes } from '../../const/sizes';
import { Box } from '../layout/Box';
import { getButtonHeight, useButtonColors } from './buttonConst';
const StyledButton = styled('button', (p) => ({
    borderRadius: sizes.button.borderRadius,
    borderStyle: 'none',
    height: p.$height,
    width: p.$width,
    padding: 0,
    color: p.$buttonColors.text.normalState,
    backgroundColor: p.$buttonColors.background.normalState,
    cursor: 'pointer',
    ':active': {
        boxShadow: `inset 0 0 0 2px ${p.$buttonColors.text.normalState}`,
    },
    ':disabled': {
        color: p.$buttonColors.text.disabledState,
        backgroundColor: p.$buttonColors.background.disabledState,
        textDecorationColor: p.$buttonColors.text.disabledState,
        cursor: 'not-allowed',
    },
    ':hover': {
        color: p.$buttonColors.text.hoveredState,
        backgroundColor: p.$buttonColors.background.hoveredState,
        textDecorationColor: p.$buttonColors.text.hoveredState,
    },
}));
export const ButtonContainer = forwardRef(({ children, color, size, variant, width, ...restProps }, ref) => {
    const height = getButtonHeight(size);
    const buttonsColors = useButtonColors({ color, variant });
    return (_jsx(StyledButton, { ref: ref, $height: height, $width: width, $buttonColors: buttonsColors, ...restProps, children: _jsx(Box, { spacingHorizontal: true, children: children }) }));
});
